<template>
  <VModal name="addedit-apikey-modal" :loading="loading" v-if="apikey">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('companySettings.developer.apikeys.edit') }}</h2>
    </template>
    <template v-slot:content>
      <VForm :onSubmit="validateForm" data-vv-scope="apikey" ref="form">

        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="12">
              <b>{{ $t('companySettings.developer.apikeys.name') }}</b>
              <VInput
                type="text"
                data-ec="add_edit_api_key_modal"
                data-et="api_key_name_input"
                v-validate="'required'"
                data-vv-name="name"
                :data-vv-as="$t('companySettings.developer.apikeys.name')"
                v-model="apikey.name"
                data-vv-scope="apikey"
                :class="{ 'a-input--error': errors.has('apikey.name') }"
                data-hj-suppress
              />
              <VMessage
                type="error"
                subtype="basic"
                v-show="errors.has('apikey.name')">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('apikey.name') }}
                </template>
              </VMessage>
            </div>
            <div slot="gridItem" type="6" v-if="isNew">
              <b>{{ getKeyHeader }}</b>

              <VCheckbox
                type="checkbox"
                subtype="toggle"
                size="small"
                data-ec="add_edit_api_key_modal"
                data-et="api_key_is_live_checkbox"
                :checked="isLive"
                v-model="isLive"
              />
              <span class="checkbox-status-indicator">{{ type }}</span>
            </div>

            <div slot="gridItem" type="4" v-if="!isNew">
              <b>{{ $t('companySettings.developer.apikeys.type') }}</b>
              <span v-if="!isNew">
                {{ $t(`companySettings.developer.apikeys.types.${apikey.type}`) }}
              </span>

            </div>
            <div slot="gridItem" type="8"><a target="_blank" href="https://documenter.getpostman.com/view/2304617/UVJYLKjV#test-vs-live-api-keys">{{ $t('companySettings.developer.apiKeysDifference') }}</a></div>
            <div slot="gridItem" type="8" v-if="!isNew">
              <VButton
                  type="outline-1"
                  v-if="!showKey"
                  data-ec="add_edit_api_key_modal"
                  data-et="show_api_key_button"
                  @click="showKey = true">
                <span>{{ $t('companySettings.developer.apikeys.show') }}</span>
              </VButton>

              <div slot="gridItem" type="8" v-if="showKey">
                <b>{{ $t('companySettings.developer.apikeys.key') }}</b>
                {{apikey.key}}
              </div>

            </div>


          </VGrid>
        </div>

        <div slot="formButtons" type="right">
          <VButton
            type="success"
            subtype="submit"
            data-ec="add_edit_api_key_modal"
            data-et="save_button">
            <SaveIcon />
            <span>{{ $t('functional.save')}}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import { SaveIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'AddEditApiKeyModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    item: Object,
  },
  components: {
    VButton,
    VInput,
    VMessage,
    VForm,
    VGrid,
    VModal,
    VCheckbox,
    SaveIcon,
    XMarkIcon,
  },
  watch: {
    // Duplicate copied data in to modal
    item(newItem) {
      this.apikey = JSON.parse(JSON.stringify(newItem));
    },
  },
  data() {
    return {
      loading: false,
      showKey: false,
      apikey: {},
    };
  },
  computed: {
    isNew() {
      return !this.apikey.id;
    },
    isLive: {
      get() {
        return this.apikey.type === 'live';
      },
      set(isLive) {
        this.apikey.type = isLive ? 'live' : 'test';
      },
    },
    type() {
      return this.isLive ? this.$t('companySettings.developer.apikeys.types.live') : this.$t('companySettings.developer.apikeys.types.test');
    },
    getKeyHeader() {
      return this.isLive ? this.$t('companySettings.developer.apikeys.production') : this.$t('companySettings.developer.apikeys.test');
    },
  },
  methods: {
    validateForm(scope) {
      this.loading = true;
      this.$validator.validateAll(scope).then((validated) => {
        if (!validated) {
          this.loading = false;
          return;
        }
        if (this.isNew) {
          this.$store.dispatch('apiKeys/CREATE', this.apikey).then((res) => {
            this.loading = false;
            this.apikey = res.data.data; // Reload this apikey in modal from response data
          }).catch(() => {
            this.loading = false;
          });
        } else {
          this.$store.dispatch('apiKeys/UPDATE', this.apikey).then(() => {
            this.$bus.$emit('closeModal');
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.checkbox-status-indicator {
  vertical-align: top;
  margin-left: var(--spacing-base);
  font-weight: bold;
}
</style>
